import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import api from "@/lib/api";

/**
 * Labeled, auto-scrolling advertisement banner for the homepage.
 * Clearly marked "Advertisement" per DYORUSA policy. Pauses on hover and
 * respects prefers-reduced-motion. Items link to the advertising pages.
 */
export default function RunningBanner() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/ad-packages")
      .then((r) => {
        const avail = (r.data || []).filter((p) => p.availability === "available");
        const msgs = avail.length
          ? avail.map((p) => `${p.name} — sponsorship available`)
          : ["Reach the data-center buildout — advertise with DYORUSA"];
        msgs.push("Your brand here — clearly labeled, transparent placements");
        msgs.push("12 Stone Development Group LLC — ask about JV opportunities!!");
        setItems(msgs);
      })
      .catch(() => setItems(["Reach the data-center buildout — advertise with DYORUSA", "12 Stone Development Group LLC — ask about JV opportunities!!"]));
  }, []);

  if (!items.length) return null;
  const loop = [...items, ...items];

  return (
    <div data-testid="ad-running-banner" className="relative w-full border-b border-white/10 bg-[#0B0F17] overflow-hidden">
      <div className="flex items-stretch">
        <div className="shrink-0 z-10 flex items-center gap-1.5 bg-[#84CC16] text-[#0B0F17] px-3 font-mono text-[10px] font-bold uppercase tracking-widest">
          <Megaphone size={12} /> Ad
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex items-center gap-10 py-2 whitespace-nowrap">
            {loop.map((m, i) => (
              <Link key={i} to="/advertise/pricing" aria-hidden={i >= items.length}
                className="text-sm text-slate-300 hover:text-[#84CC16] transition-colors inline-flex items-center gap-2 shrink-0">
                <span className="w-1.5 h-1.5 rounded-full bg-[#3B82F6]" /> {m}
              </Link>
            ))}
          </div>
          {/* soft fade edges */}
          <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-[#0B0F17] to-transparent" />
        </div>
      </div>
    </div>
  );
}
